// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2PvXS","location":"Header_location__1wgdu"};